const ErrorPageDescription = ({ children }: { children: React.ReactNode }) => {
    return (
        <div className="font-bold lg:text-4xl text-yellow-40 text-center whitespace-pre-line pb-6 lg:pt-6">{children}</div>
    )
}

export default ErrorPageDescription
